export default __webpack_public_path__ + "static/media/commercialheader.d6b6b993.jpg";